/**
 * Tracks that the creator reached a brand's explore page via the brand's shared
 * Creator Link. The dashboard mints a signed token into the link's `?inbound=`
 * query param; collab requests submitted with it are tagged `source: 'inboundLink'`
 * so the brand's dashboard can approve them onto the platform and file them into
 * its inbound list. localStorage (not sessionStorage) so the tag survives a signup
 * interrupted and finished in another tab/session; the token is client-bound and
 * verified server-side, so a stale entry can only ever tag requests for the brand
 * that issued it.
 */
export const INBOUND_LINK_QUERY_PARAM = 'inbound';

const storageKey = (clientId: string) => `inboundLinkToken:${clientId}`;

export const storeInboundLinkToken = (clientId: string, token: string): void => {
  try {
    localStorage.setItem(storageKey(clientId), token);
  } catch {
    // storage unavailable (e.g. private mode) — attribution is best-effort
  }
};

/** Stores the Creator Link token carried in the page URL, if one is present. */
export const captureInboundLinkToken = (clientId: string, searchParams: URLSearchParams): void => {
  const token = searchParams.get(INBOUND_LINK_QUERY_PARAM);
  if (token) {
    storeInboundLinkToken(clientId, token);
  }
};

export const getInboundLinkToken = (clientId: string): string | undefined => {
  try {
    return localStorage.getItem(storageKey(clientId)) ?? undefined;
  } catch {
    return undefined;
  }
};
